import { TypographyP   } from "@/components/ui/typography" 
import { useBaseStore } from "@/store"
import { Store } from "@/store/type"
import { ArrowRight, Clipboard, User, ShieldUser } from "lucide-react"
import { Link } from "react-router-dom"

const stateSelector = (state: Store) => ({ 
    user: state.authSlice.state.user,
    profile: state.authSlice.state.profile
})
 
const Home = () => {
    const { user, profile } = useBaseStore(stateSelector)
    
    return (
        <div className="flex flex-col h-full overflow-auto p-4 bg-gray-50">
            <TypographyP className="text-base text-gray-600">
                Olá, <span className="font-semibold text-gray-900">{user}</span> 👋
            </TypographyP> 
           
           <div className="md:grid-cols-2 lg:grid-cols-3 grid mt-4 gap-4">
               
               <Link 
                    to={'/market-research'}
                    className="w-full bg-gradient-to-br from-primary-400 to-primary-700 rounded-2xl p-4 shadow-lg hover:shadow-xl transition-all text-left group"
                >
                    <div className="flex items-start justify-between mb-2">
                        <div className="w-10 h-10 rounded-xl bg-white bg-opacity-20 flex items-center justify-center"> 
                            <Clipboard className="w-5 h-5 text-white" />
                        </div>
                        <div className="w-8 h-8 rounded-full bg-white bg-opacity-20 flex items-center justify-center group-hover:bg-opacity-30 transition-all">
                            <ArrowRight className="w-5 h-5 text-white" />
                        </div>
                    </div>
                    <h2 className="text-xl font-bold text-white mb-2">
                        Planejamento de Pesquisa
                    </h2>
                    <p className="text-emerald-50 text-sm leading-relaxed">
                       Acompanhe e efetue suas pesquisa
                    </p>
                </Link>
                {profile == "ADMINISTRADOR" && (
                    <>
                        <Link 
                            to={'/access/user'}
                            className="w-full bg-gradient-to-br from-primary-400 to-primary-700 rounded-2xl p-4 shadow-lg hover:shadow-xl transition-all text-left group"
                        >
                            <div className="flex items-start justify-between mb-3">
                                <div className="w-10 h-10 rounded-xl bg-white bg-opacity-20 flex items-center justify-center"> 
                                    <User className="w-5 h-5 text-white" />
                                </div>
                                <div className="w-8 h-8 rounded-full bg-white bg-opacity-20 flex items-center justify-center group-hover:bg-opacity-30 transition-all">
                                    <ArrowRight className="w-5 h-5 text-white" />
                                </div>
                            </div>
                            <h2 className="text-xl font-bold text-white mb-2">
                                Usuários
                            </h2>
                            <p className="text-emerald-50 text-sm leading-relaxed">
                                Cadastre e efetue manutenções dos usuários
                            </p>
                        </Link>

                        <Link 
                            to={'/access/user-permissions'}
                            className="w-full bg-gradient-to-br from-primary-400 to-primary-700 rounded-2xl p-4 shadow-lg hover:shadow-xl transition-all text-left group"
                        >
                            <div className="flex items-start justify-between mb-3">
                                <div className="w-10 h-10 rounded-xl bg-white bg-opacity-20 flex items-center justify-center"> 
                                    <ShieldUser className="w-5 h-5 text-white" />
                                </div>
                                <div className="w-8 h-8 rounded-full bg-white bg-opacity-20 flex items-center justify-center group-hover:bg-opacity-30 transition-all">
                                    <ArrowRight className="w-5 h-5 text-white" />
                                </div>
                            </div>
                            <h2 className="text-xl font-bold text-white mb-2">
                                Permissões de acesso
                            </h2>
                            <p className="text-emerald-50 text-sm leading-relaxed">
                                Efetue manutenções nos acessos dos usuários
                            </p>
                        </Link>
                    </>
                )}
                
           </div>

        </div>
    )
}

export default Home
